//frontend/src/dropdownMap/1A5b_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    11: "ConductedBy",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    ConductedBy: {
        internal: ["dafo", "deso", "dho", "gst", "maf", "npco", "pafo", "wfp"],
        LA: {
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "deso": "ຫ້ອງການສຶກສາເມືອງ",
            "dho": "ຫ້ອງການສາທາເມືອງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "maf": "ກະຊວງ ກປ",
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ"
        },
        EN: {
            "dafo": "DAFO",
            "deso": "DESO",
            "dho": "DHO",
            "gst": "GST",
            "maf": "MAF",
            "npco": "NPCO",
            "pafo": "PAFO",
            "wfp": "WFP"
        }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
